import { useState } from "react";
import { ArrowRight, Play } from "lucide-react";
import { PAYMENT_URL, VIDEO_THUMB, VIDEO_EMBED_URL, VIDEO_POSTER } from "../lib/site";
import { SectionHead, Reveal, CtaButton } from "./Reveal";

export default function VideoSection() {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="preview" data-testid="video-section" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <SectionHead
          eyebrow="Watch First"
          title={<>See How It Works <span className="bg-gradient-to-r from-[#9B5CF0] to-[#6D28D9] bg-clip-text text-transparent">Before You Join.</span></>}
          sub="A quick walkthrough of what you'll learn and how the two-day bootcamp works."
          testId="video"
        />

        <Reveal delay={0.2} className="mt-12">
          <div className="relative overflow-hidden rounded-3xl border border-[#E9DFFC] shadow-[0_40px_80px_-30px_rgba(28,16,45,0.35)]" data-testid="video-preview-card">
            {playing ? (
              <iframe
                src={VIDEO_EMBED_URL}
                title="DPA 2-Day AI Bootcamp — intro video"
                className="aspect-video w-full"
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                data-testid="video-iframe"
              />
            ) : (
              <button
                type="button"
                onClick={() => setPlaying(true)}
                aria-label="Play bootcamp intro video"
                className="group relative block w-full transition-[transform,box-shadow] duration-300 hover:shadow-[0_50px_90px_-30px_rgba(124,58,237,0.4)]"
              >
                <img
                  src={VIDEO_POSTER}
                  alt="Bootcamp intro video — Anuj Tiwari explains the 2-day AI bootcamp"
                  className="aspect-video w-full object-cover"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = VIDEO_THUMB;
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1C102D]/60 via-[#1C102D]/10 to-transparent" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="relative flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-r from-[#9B5CF0] to-[#6D28D9] text-white shadow-[0_15px_40px_rgba(124,58,237,0.6)] transition-transform duration-300 group-hover:scale-110">
                    <span className="ping-soft absolute inset-0 rounded-full bg-[#7C3AED]" />
                    <Play size={26} fill="currentColor" className="relative ml-1" />
                  </span>
                </span>
                <span className="absolute bottom-4 left-4 rounded-full bg-black/50 px-3.5 py-1.5 font-mono text-[11px] font-bold uppercase tracking-widest text-white backdrop-blur-sm">
                  Bootcamp Preview
                </span>
              </button>
            )}
          </div>
        </Reveal>

        <Reveal delay={0.3} className="mt-9 text-center">
          <CtaButton href={PAYMENT_URL} testId="video-section-cta">
            Join the Bootcamp — ₹199 <ArrowRight size={17} strokeWidth={2.5} />
          </CtaButton>
        </Reveal>
      </div>
    </section>
  );
}
